import { jwtDecode } from 'jwt-decode';
import React, { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

export const AuthContext = createContext();
const API_URL = 'http://localhost:8000'; // change if needed

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authToken, setAuthToken] = useState(null);
    const [userEmail, setUserEmail] = useState(null);
    const [userId, setUserId] = useState(null); // ✅ Add userId to state
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('bbauthToken');
        if (token) {
            const decoded = jwtDecode(token);
            setUserId(decoded.user_id); // ✅ Set user ID from JWT
            setUserEmail(decoded.email);
            setAuthToken(token);
            setIsAuthenticated(true);

            axios
                .post(`${API_URL}/validate-token`, { token })
                .then((res) => {
                    if (res.data.status !== 'success') {
                        logout();
                    }
                })
                .catch(() => logout())
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = (token, email, given_name, family_name) => {
        const decoded = jwtDecode(token);
        localStorage.setItem('bbauthToken', token);
        setAuthToken(token);
        setUserEmail(email);
        setUserId(decoded.user_id); // ✅ Extract userId during login
        setIsAuthenticated(true);
        axios.post(`${API_URL}/api/event_userlogin`, { email, given_name, family_name });
    };

    const logout = () => {
        try {
            localStorage.removeItem('bbauthToken');
            localStorage.setItem('bbgenerationCount', '0');
        } catch (e) {
            console.warn('Logout failed:', e);
        }
        setIsAuthenticated(false);
        setAuthToken(null);
        setUserEmail(null);
        setUserId(null);
    };

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                authToken,
                userEmail,
                userId, // ✅ Provide userId
                login,
                logout,
                loading,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
